import { axios, HOST, config } from "./settiing";

export default {
  // Drive Schedule
  getMonthlyDriveSchedule(date) {
    return axios.get(`${HOST}/manage/driverschedule/month/${date}`, config);
  },
  getDailyDriveSchedule(date) {
    return axios.get(`${HOST}/manage/driverschedule/day/${date}`, config);
  },
  getPeriodDriveSchedule(start, end) {
    return axios.get(
      `${HOST}/manage/driverschedule/date/${start}/${end}`,
      config
    );
  },
  updateDriveSchedule(data) {
    return axios.post(`${HOST}/manage/driverschedule`, data, config);
  },

  replaceDriverSchedule(data) {
    return axios.post(`${HOST}/manage/driverschedule/replace`, data, config);
  },

  addDriveScheduleDrt(data) {
    return axios.post(`${HOST}/manage/driverschedule/drt`, data, config);
  },
  addEditDriveRestSchedule(data) {
    //기사 휴식 일정 등록
    return axios.post(`${HOST}/manage/web/driver-schedule/rest`, data, config);
  },
  getNewDriverSchedule(date) {
    //new 기사 근무 일정
    return axios.get(`${HOST}/manage/web/driver-schedule/${date}`, config);
  },
  deleteDriverRest(restId) {
    // 기사 휴식 일정 삭제
    return axios.delete(
      `${HOST}/manage/web/driver-schedule/rest/${restId}`,
      config
    );
  },
  deleteDriverSchedule(id) {
    // 기사 근무 일정 삭제
    return axios.delete(`${HOST}/manage/web/driver-schedule/${id}`, config);
  },
};
